import Slide from './slide';
import Mask from './mask';
import Send from './send';
import MenuToggle from './menutoggle';
import ScrollTo from './scrollto';
import CountTo from './countto';
import Gallery from './gallery';

class Common {
  constructor() {
    // Instance imports
    new Slide();
    new Mask();
    new Send();
    new MenuToggle();
    new ScrollTo();
    new CountTo();
    new Gallery();

    // Call methods
    this.fixedI10();
    this.disableZoomGesture();
  }

  fixedI10() {
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
      const msViewportStyle = document.createElement('style');
      msViewportStyle.appendChild(document.createTextNode('@-ms-viewport{width:auto!important}'));
      document.querySelector('head').appendChild(msViewportStyle);
    }
  }

  disableZoomGesture() {
    document.addEventListener('gesturestart', (e) => {
      e.preventDefault();
    });
  }
}

export default Common;
